import { Pipe, PipeTransform } from "@angular/core";

@Pipe(
  {
    name: 'filtroArray',
    pure: true
  })

export class FiltroArrayPipe implements PipeTransform
{
  constructor( )
  {
  }

  transform(items : Array<any>, buscar : Array<any>,  atributo : string)
  {
    if (!items || !buscar || items.length == 0 || buscar.length == 0)
    {
      return items;
    }

    return items.filter((item : any) =>
    {
      return buscar.indexOf(item[atributo]) >= 0;
    });
  }

}
